var app = angular.module("leonardo");

var PortfolioSelectorDialog = function($scope, FormErrorsService) {
  $scope.account = $scope.ngDialogData.account;

  $scope.data = {
    portfolios: null
  };

  $scope.submit = function() {
    $scope.Form.$setSubmitted();
    if ($scope.Form.$invalid) {
      FormErrorsService.goToError();
      return;
    }
    $scope.confirm($scope.data.portfolios);
  };
};

app.controller('PortfolioSelectorDialog', ['$scope', 'FormErrorsService', PortfolioSelectorDialog]);
